
import { RouteName } from './routenames';

export default {
    props: {
        video: {
            type: Object,
            required: true,
        },
        categoryid: {
            type: String,
            required: true,
        },
    },

    methods: {
        openVideo() {
            this.$router.push({
                name: RouteName.VideoRoute,
                params: {
                    seoname: this.video.SeoName,
                    categoryid: this.video.Category,
                },
            });
        }
    }
}
